function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDebtBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M348.105,144.54L380.878,0H131.122l32.773,144.539C83.188,180.004,26.821,260.632,26.821,354.44 c0,61.039,23.88,116.486,62.786,157.56h332.781c38.907-41.074,62.79-96.521,62.79-157.56 C485.179,260.633,428.81,180.005,348.105,144.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5023"
    },
    d: "M348.105,144.54L380.878,0H256v512h166.389c38.907-41.074,62.79-96.521,62.79-157.56 C485.179,260.633,428.81,180.005,348.105,144.54z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.351,
    y: 112.39,
    style: {
      fill: "#FFE98F"
    },
    width: 207.298,
    height: 37.463
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 112.39,
    style: {
      fill: "#FFDA44"
    },
    width: 103.649,
    height: 37.463
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtBag);
export default __webpack_public_path__ + "static/media/debtBag.c48c8b4a5cfbb57091965f96b636b7ff.svg";
export { ForwardRef as ReactComponent };